export enum PaymentProcessor {
    WORLDPAYXML = 'WPAYXML',
    PAYVISION = 'PVISION',
    WPAY = 'WPAY',
    NETWORKINTERNATIONAL = 'NI'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/models/payments/payment-processor.enum.ts